// import axios from "axios";
let axios = null;
let CancelToken = null; // axios.CancelToken;
let uitl = {};
Object.defineProperty(uitl, "axios", {
  get() {
    if (!axios) {
      axios = require("axios");
    }
    return axios;
  },
  enumerable: true,
  configurable: true
});

Object.defineProperty(uitl, "CancelToken", {
  get() {
    if (!CancelToken) {
      CancelToken = uitl.axios.CancelToken;
    }
    return CancelToken;
  },
  enumerable: true,
  configurable: true
});

const STATUS = {
  // 生成hash中
  readying: "readying",
  // 已生成hash，还没开始上传
  ready: "ready",
  // 正在上传
  uploading: "uploading",
  // 已暂停
  suspend: "suspend",
  // 人为终止
  stop: "stop",
  // 上传完成
  finish: "finish",
  // 上传异常
  error: "error"
};

const EVENT_TYPE = {
  ready: "ready",
  uploading: "uploading",
  suspend: "suspend",
  stop: "stop",
  finish: "finish",
  error: "error",
  speed: "speed"
};

const blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice;
const _fileToHash = window.Worker ? _asyncFileToHash : _syncFileToHash;

/**
 * 分片上传器
 */
class SplitUploader {
  static STATUS = STATUS;
  static EVENT_TYPE = EVENT_TYPE;

  #_hash = null;
  #_status = ""; // 状态
  #_file = null;
  #_threshold = dsf.config.setting_public_upload_split_threshold; // 50MB 低于这个值就直接上传文件
  #_chunkSize = 2097152; // 2MB 切片大小
  #_currentChunk = 0; // 当前上传切片的索引
  #_chunks = 0; // 切片的总数
  #_owner = null; // vue控件实例

  #_cancelToken = null;

  #_uploadFileUrl = "file/upload/"; // 上传单文件地址
  #_queryChunkUrl = "/file/check"; // 查询切片地址
  #_uploadChunkUrl = "/file/uploadChunk"; // 上传切片地址

  // 接口额外传参
  #_extendData = {
    isPublic: 1, // 是否公开
    isStatic: 0 // 是否静态, 如果选择了静态，公开私有就会失效
  };

  #_speedLoaded = 0;
  #_speedLoaded2 = 0;
  #_speed = 0;
  #_timeout = null;

  // 事件
  #_listener = {
    ready: [],
    uploading: [],
    suspend: [],
    stop: [],
    finish: [],
    error: [],
    speed: []
  };

  /**
   * 要上传的文件
   * @returns {null}
   */
  get file() {
    return this.#_file;
  }

  /**
   * hash值
   * @returns {null | string}
   */
  get hash() {
    return this.#_hash;
  }

  /**
   * 状态
   * @returns {string}
   */
  get status() {
    return this.#_status;
  }

  /**
   * vue实例
   * @returns {string}
   */
  get owner() {
    return this.#_owner;
  }

  /**
   * 分片上传器
   * @param options.chunkSize {number} 切片大小，默认2MB
   * @param options.threshold {number} 默认50MB，低于这个值就直接上传文件
   * @param options.uploadFileUrl {string} 上传单文件地址
   * @param options.queryChunkUrl {string} 查询切片地址
   * @param options.uploadChunkUrl {string} 上传切片地址
   * @param options.extendData {object} 接口额外传参
   * @param options.owner {object} vue控件实例
   */
  constructor(options = {}) {
    if (dsf.isNumber(options.chunkSize)) {
      this.#_chunkSize = options.chunkSize;
    }
    if (dsf.isNumber(options.threshold)) {
      this.#_threshold = options.threshold;
    } else {
      this.#_threshold = dsf.config.setting_public_upload_split_threshold;
    }
    if (dsf.isString(options.uploadFileUrl)) {
      this.#_uploadFileUrl = options.uploadFileUrl;
    }
    if (dsf.isString(options.queryChunkUrl)) {
      this.#_queryChunkUrl = options.queryChunkUrl;
    }
    if (dsf.isString(options.uploadChunkUrl)) {
      this.#_uploadChunkUrl = options.uploadChunkUrl;
    }
    if (dsf.isString(options.owner)) {
      this.#_owner = options.owner;
    }
    if (dsf.isObject(options.extendData)) {
      this.#_extendData = Object.assign(
        {
          isPublic: 1, // 是否公开
          isStatic: 0 // 是否静态, 如果选择了静态，公开私有就会失效
        },
        options.extendData
      );
    }
  }

  /**
   * 载入文件
   * @param file
   * @param autoRun 是否自动执行上传
   * @returns {SplitUploader}
   */
  load(file, autoRun = true) {
    this.#_hash = null;
    this.#_file = file;
    this.#_speedLoaded = 0;
    this.#_speedLoaded2 = 0;
    this.#_speed = 0;
    if (file.size < this.#_threshold) {
      this.#_status = STATUS.ready;
      this.#_emit(EVENT_TYPE.ready);
      autoRun && this.run();
      return this;
    }
    this.#_currentChunk = 0;
    this.#_chunks = Math.ceil(file.size / this.#_chunkSize);
    this.#_status = STATUS.readying;
    fileToHash(file)
      .then((hash) => {
        this.#_hash = hash;
        this.#_status = STATUS.ready;
        this.#_emit(EVENT_TYPE.ready, hash);
        autoRun && this.run();
      })
      .catch((error) => {
        this.#_status = STATUS.error;
        this.#_emit(EVENT_TYPE.error, error);
      });
    return this;
  }

  /**
   * 开始或继续
   */
  run() {
    if (!this.#_file) return this;
    this.#_run();
    let fn = () => {
      if (this.#_status !== STATUS.uploading) return;
      this.#_timeout = setTimeout(() => {
        let total = this.#_file.size;
        let progress = _.floor((this.#_speedLoaded * 10000) / total) / 100 || 0;
        if (progress > 100) {
          progress = 100;
        }
        this.#_speed = Math.round((this.#_speedLoaded - this.#_speedLoaded2) / 2);
        this.#_speedLoaded2 = this.#_speedLoaded;
        this.#_emit(EVENT_TYPE.speed, {
          progress,
          speed: this.#_speed,
          _speed: sizeToString(this.#_speed) + "/s"
        });
        fn();
      }, 2000);
    };
    clearTimeout(this.#_timeout);
    fn();
    return this;
  }

  /**
   * 暂停
   */
  suspend() {
    if (!this.#_file) return this;
    clearTimeout(this.#_timeout);
    this.#_cancelToken?.cancel(STATUS.suspend);
    this.#_speedLoaded = 0;
    this.#_speedLoaded2 = 0;
    this.#_speed = 0;
    this.#_status = STATUS.suspend;
    return this;
  }

  /**
   * 终止
   */
  stop() {
    if (!this.#_file) return this;
    clearTimeout(this.#_timeout);
    this.#_cancelToken?.cancel(STATUS.stop);
    this.#_hash = null;
    this.#_file = null;
    this.#_currentChunk = 0;
    this.#_chunks = 0;
    this.#_speedLoaded = 0;
    this.#_speedLoaded2 = 0;
    this.#_speed = 0;
    this.#_status = STATUS.stop;
    this.#_emit(EVENT_TYPE.stop);
    return this;
  }

  /**
   * 事件监听
   * @param event
   * @param listener
   * @returns {SplitUploader}
   */
  on(event, listener) {
    if (!this.#_listener[event] || !dsf.isFunction(listener)) return this;
    let index = _.findIndex(this.#_listener[event], (fn) => fn === listener);
    if (index == -1) {
      this.#_listener[event].push(listener);
    }
  }

  /**
   * 取消事件监听
   * @param event
   * @param listener
   * @returns {SplitUploader}
   */
  off(event, listener) {
    if (!this.#_listener[event]) return this;
    if (listener === void 0) {
      this.#_listener[event] = [];
      return this;
    }
    if (dsf.isFunction(listener)) {
      let index = _.findIndex(this.#_listener[event], (fn) => fn === listener);
      if (index > -1) {
        this.#_listener[event].splice(index, 1);
      }
    }
    return this;
  }

  /**
   * 触发事件
   * @param type
   * @param data
   */
  #_emit = (type, data) => {
    if (!this.#_listener[type]?.length) return;
    _.each(this.#_listener[type], (fn) => fn(data));
  };

  #_getEvent = (loaded, offLoaded) => {
    let total = this.#_file.size;
    let progress = _.floor((loaded * 10000) / total) / 100 || 0;
    if (progress > 100) {
      progress = 100;
    }
    this.#_speedLoaded += offLoaded;
    return {
      loaded,
      total,
      progress,
      speed: this.#_speed,
      _loaded: sizeToString(loaded),
      _total: sizeToString(total),
      _speed: sizeToString(this.#_speed) + "/s"
    };
  };

  #_run = async () => {
    let _status = this.#_status;
    this.#_status = STATUS.uploading;
    this.#_emit(EVENT_TYPE.uploading, this.#_getEvent(this.#_currentChunk * this.#_chunkSize, 0));
    if (this.#_file.size < this.#_threshold) {
      try {
        this.#_cancelToken = uitl.CancelToken.source();
        let resInfo = await uploadFile.call(this, this.#_cancelToken.token, this.#_uploadFileUrl, this.#_file, this.#_extendData, ({ loaded, offLoaded }) => {
          // 处理上传进度
          this.#_emit(EVENT_TYPE.uploading, this.#_getEvent(loaded, offLoaded));
        });
        this.#_status = STATUS.finish;
        this.#_emit(EVENT_TYPE.finish, resInfo);
      } catch (e) {
        clearTimeout(this.#_timeout);
        this.#_status = STATUS.error;
        this.#_emit(EVENT_TYPE.error, e);
      }
      return this;
    }
    try {
      if (_status !== STATUS.suspend) {
        let res = await queryCurrentChunk.call(this, this.#_queryChunkUrl, this.#_hash, this.#_file, this.#_extendData);
        // 未上传
        if (res.upload == 0) {
          this.#_currentChunk = 0;
        }
        // 已上传部分
        else if (res.upload == 1) {
          this.#_currentChunk = res.chunkIndex;
        }
        // 已上传成功
        else {
          this.#_status = STATUS.finish;
          this.#_emit(EVENT_TYPE.finish, [res.fileInfo]);
          return;
        }
      }
      let resInfo = null;
      while (this.#_currentChunk < this.#_chunks && this.#_status === STATUS.uploading) {
        let start = this.#_currentChunk * this.#_chunkSize,
          end = start + this.#_chunkSize >= this.#_file.size ? this.#_file.size : start + this.#_chunkSize;
        let blob = blobSlice.call(this.#_file, start, end);
        this.#_cancelToken = uitl.CancelToken.source();
        resInfo = await uploadChunk.call(
          this,
          this.#_cancelToken.token,
          this.#_uploadChunkUrl,
          this.#_hash,
          blob,
          this.#_file,
          this.#_currentChunk,
          this.#_chunks,
          this.#_extendData,
          ({ loaded, offLoaded }) => {
            // 处理上传进度
            this.#_emit(EVENT_TYPE.uploading, this.#_getEvent(start + loaded, offLoaded));
          }
        );
        this.#_currentChunk++;
      }
      this.#_cancelToken = null;
      if (this.#_status === STATUS.uploading) {
        this.#_status = STATUS.finish;
        this.#_emit(EVENT_TYPE.finish, resInfo);
      }
    } catch (e) {
      clearTimeout(this.#_timeout);
      this.#_cancelToken = null;
      switch (e?.message) {
      case STATUS.stop:
        break;
      case STATUS.suspend:
        this.#_emit(EVENT_TYPE.suspend, this.#_getEvent(this.#_currentChunk * this.#_chunkSize, 0));
        break;
      default:
        this.#_status = STATUS.error;
        this.#_currentChunk = 0;
        this.#_speedLoaded = 0;
        this.#_speedLoaded2 = 0;
        this.#_speed = 0;
        this.#_emit(EVENT_TYPE.error, e);
      }
    }
    return this;
  };
}

/**
 * 生成文件唯一hash
 * @param file
 * @returns {string}
 */
function fileToHash(file) {
  return new Promise((resolve, reject) => {
    _fileToHash(
      file,
      (hash) => {
        resolve(hash);
      },
      (err) => reject({ message: err.message })
    );
  });
}

/**
 * 分片上传
 * @param file
 * @param options
 * @returns {SplitUploader}
 */
function createUploader(file, options) {
  return new SplitUploader(options).load(file, true);
}

function sizeToString(size) {
  if (size < 1048576) {
    return _.round(size / 1024, 2) + "KB";
  }
  if (size < 1073741824) {
    return _.round(size / 1048576, 2) + "MB";
  }
  return _.round(size / 1073741824, 2) + "GB";
}

// worker 生成hash
let _worker = null,
  _workerIds = {};
function _asyncFileToHash(file, cb, error) {
  if (!_worker) {
    _worker = new Worker(dsf.url.getWebPath("$/js/libs/sparkMd5/worker.js"));
    _worker.addEventListener("message", (e) => {
      let { success, id, data, message } = e.data;
      if (!_workerIds[id]) return;
      if (success) {
        _workerIds[id].cb(data);
      } else {
        _workerIds[id].error(message);
      }
      delete _workerIds[id];
    });
  }
  let id = dsf.uuid();
  _workerIds[id] = { cb, error };
  _worker.postMessage({ id, file });
}

// 当前线程生成hash
function _syncFileToHash(file, cb, error) {
  dsf.http
    .importFiles(dsf.url.getWebPath("$/js/libs/sparkMd5/index.min.js"))
    .then(() => {
      const spark = new SparkMD5.ArrayBuffer();
      let chunkSize = 2097152,
        currentChunk = 0,
        chunks = Math.ceil(file.size / chunkSize);

      let fileReader = new FileReader();
      fileReader.onload = function (e) {
        spark.append(e.target.result);
        currentChunk++;
        if (currentChunk < chunks) {
          loadNext();
        } else {
          var hash = spark.end();
          cb(hash);
        }
      };
      fileReader.onerror = (e) => error(e.message);

      function loadNext() {
        let start = currentChunk * chunkSize,
          end = start + chunkSize >= file.size ? file.size : start + chunkSize;
        let blob = blobSlice.call(file, start, end);
        fileReader.readAsArrayBuffer(blob);
      }
      loadNext();
    })
    .catch((e) => {
      error(e.message);
    });
}

/**
 * 查询当前文件上传的分片索引
 * @param url
 * @param hash
 * @param file
 * @param extendData
 * @returns {Promise<Object>}
 */
function queryCurrentChunk(url, hash, file, extendData) {
  let options = [
    url,
    {
      ...extendData,
      fileHash: hash,
      originalFileName: file.name,
      size: file.size,
      contentType: file.type
    }
  ];
  return (this.owner?.$http ? this.owner.$http.get(...options, true) : dsf.http.get(...options)).done(({ success, data, message }) => {
    if (success) {
      return data;
    }
    throw { message };
  });
}
// function queryCurrentChunk(url, hash, file, extendData) {
//   return new Promise((resolve) => {
//     setTimeout(() => resolve({
//       upload: 0
//     }), 1000);
//   });
// }

/**
 * 单个分片上传
 * @param cancelToken
 * @param url
 * @param hash
 * @param blob
 * @param file
 * @param currentChunk
 * @param chunks
 * @param extendData
 * @param handleProgress
 * @returns {Promise<Object>}
 */
function uploadChunk(cancelToken, url, hash, blob, file, currentChunk, chunks, extendData, handleProgress) {
  let oldLoaded = 0;
  let options = [
    url,
    {
      ...extendData,
      fileHash: hash,
      chunkIndex: currentChunk + 1,
      chunkCount: chunks,
      file: blob,
      originalFileName: file.name,
      size: file.size,
      contentType: file.type
    },
    {
      cancelToken,
      onUploadProgress: ({ loaded }) => {
        let offLoaded = loaded - oldLoaded;
        oldLoaded = loaded;
        handleProgress({ loaded, offLoaded });
      }
    }
  ];
  return (this.owner?.$http ? this.owner.$http.upload(...options, true) : dsf.http.upload(...options)).done(({ success, data, message }) => {
    if (success) {
      return data;
    }
    throw { message };
  });
}
// function uploadChunk(cancelToken, url, hash, blob, file, currentChunk, chunks, extendData, handleProgress) {
//   return new Promise((resolve, reject) => {
//     // 进度条
//     let loaded = 0;
//     let total = blob.size;
//     let cancelMsg = null;
//     source.cancel = (message = '') => {
//       cancelMsg = {message};
//     }
//     let fn = () => {
//       setTimeout(() => {
//         if (cancelMsg) {
//           reject(cancelMsg);
//           return;
//         }
//         if (_.random(0, 50) == 1) {
//           reject({message: '模拟上传失败'});
//           return;
//         }
//         let offLoaded = _.random(1000000, 1500000);
//         loaded += offLoaded;
//         if (loaded >= total) {
//           offLoaded -= loaded - total;
//           loaded = total;
//         }
//         handleProgress({loaded, offLoaded});
//         if (loaded == total) {
//           if (currentChunk + 1 == chunks) {
//             setTimeout(() => {
//               let suffix = '';
//               let dotIndex = file.name.lastIndexOf(".");
//               if (dotIndex > 0) {
//                 suffix = file.name.substring(dotIndex + 1).toLowerCase();
//               }
//               resolve([{
//                 "originalFileName": file.name,
//                 "name": file.name.replace('.' + suffix, ''),
//                 "suffix": suffix,
//                 "size": file.size,
//                 "contentType": file.type,
//                 "relativePath": "/upload/file/txt/11fc870bb8be4d729c48a3399fa5165e",
//                 "absolutePath": "http://localhost:8080/upload/file/txt/11fc870bb8be4d729c48a3399fa5165e",
//                 "uploadDate": dsf.date.format(new Date(), 'yyyy-mm-dd hh:ii:ss'),
//                 "securityLevel": null,
//                 "id": dsf.uuid(64)
//               }]);
//             }, 2000);
//           } else {
//             resolve({});
//           }
//           return;
//         }
//         fn();
//       }, 300);
//     }
//     fn();
//   });
// }

/**
 * 直接上传文件
 * @param cancelToken
 * @param url
 * @param file
 * @param extendData
 * @param handleProgress
 * @returns {Promise<Object>}
 */
function uploadFile(cancelToken, url, file, extendData, handleProgress) {
  let oldLoaded = 0;
  let options = [
    url,
    {
      ...extendData,
      file
    },
    {
      cancelToken,
      onUploadProgress: ({ loaded }) => {
        let offLoaded = loaded - oldLoaded;
        oldLoaded = loaded;
        handleProgress({ loaded, offLoaded });
      }
    }
  ];
  return (this.owner?.$http ? this.owner.$http.upload(...options, true) : dsf.http.upload(...options)).done(({ success, data, message }) => {
    if (success) {
      return data;
    }
    throw { message };
  });
}

export default {
  SplitUploader,
  fileToHash,
  createUploader,
  fileSizeToString: sizeToString
};
